function showQuizStep(stepId) {
	document.querySelectorAll('.tcc-quiz').forEach(function (quiz) {
		quiz.style.display = 'none';
	});

	var target = document.getElementById(stepId);
	if (target) {
		if (target === 'tcc-quiz-1') {
			document.querySelector('.quiz-start').style.display = 'flex';
		} else {
			target.style.display = 'block';
		}
	}
}

function startLoaderTimer(loader) {
	if (!loader || !loader.classList.contains('tcc-quiz-loader')) return;

	if (loader.__loaderTimer) {
		clearTimeout(loader.__loaderTimer);
	}

	loader.__loaderTimer = window.setTimeout(function () {
		var nextId = loader.getAttribute('data-next');
		if (nextId) {
			showQuizStep('tcc-quiz-' + nextId);
			return;
		}

		var nextQuiz = loader.nextElementSibling;
		while (nextQuiz && !nextQuiz.classList.contains('tcc-quiz')) {
			nextQuiz = nextQuiz.nextElementSibling;
		}

		if (nextQuiz && nextQuiz.id) {
			showQuizStep(nextQuiz.id);
		}
	}, 3000);
}

/* ===== GLOBAL ANSWER STORE ===== */
window.TCCQuiz = window.TCCQuiz || {};

window.TCCQuiz.answers = (function () {
	try {
		return JSON.parse(sessionStorage.getItem('tccQuizAnswers')) || {};
	} catch (e) {
		return {};
	}
})();

window.TCCQuiz.saveAnswer = function (stepId, values, labels, productChoices, question) {
	window.TCCQuiz.answers[stepId] = {
		question: question || (window.TCCQuiz.answers[stepId] && window.TCCQuiz.answers[stepId].question) || '',
		values: values,
		labels: labels,
		productChoices: productChoices || []
	};
	try {
		sessionStorage.setItem('tccQuizAnswers', JSON.stringify(window.TCCQuiz.answers));
	} catch (e) {}
};

window.TCCQuiz.getAnswer = function (stepId) {
	return window.TCCQuiz.answers[stepId] || { values: [], labels: [] };
};

window.TCCQuiz.getAllAnswers = function () {
	return window.TCCQuiz.answers;
};

window.TCCQuiz.getMatchedProductKey = function (stepId) {
	var answer = window.TCCQuiz.getAnswer(stepId);
	return answer.productChoices && answer.productChoices[0] ? answer.productChoices[0] : null;
};

/* ===== END GLOBAL ANSWER STORE ===== */

document.querySelectorAll('.tcc-quiz').forEach(function (quiz) {
	var mode = quiz.getAttribute('data-selection-mode') || 'single';
	var options = quiz.querySelectorAll('.tcc-quiz-option');
	var continueBtn = quiz.querySelector('.tcc-quiz-continue');
	var backBtn = quiz.querySelector('.tcc-quiz-back');
	var skipBtn = quiz.querySelector('.tcc-quiz-skip');

	function getSelectedOptions() {
		return Array.from(quiz.querySelectorAll('.tcc-quiz-option.tcc-is-selected'));
	}

	function persistAnswers() {
		var selected = getSelectedOptions();
		var values = selected.map(function (opt) { return opt.getAttribute('data-value'); });
		var labels = selected.map(function (opt) { return opt.getAttribute('data-label'); });
		var productChoices = selected.map(function (opt) { return opt.getAttribute('data-product-choice'); });
		var question = quiz.getAttribute('data-question') || '';
		window.TCCQuiz.saveAnswer(quiz.id, values, labels, productChoices, question);
	}

	function updateContinueVisibility() {
		var hasSelection = getSelectedOptions().length > 0;
		if (continueBtn) {
			continueBtn.classList.toggle('tcc-is-visible', hasSelection);
		}
	}

	options.forEach(function (option) {
		option.addEventListener('click', function () {
			if (mode === 'single') {
				options.forEach(function (opt) {
					opt.classList.remove('tcc-is-selected');
				});
				option.classList.add('tcc-is-selected');
			} else {
				option.classList.toggle('tcc-is-selected');
			}
			updateContinueVisibility();
			persistAnswers();
		});
	});

	if (continueBtn) {
		continueBtn.addEventListener('click', function () {
			if (!continueBtn.classList.contains('tcc-is-visible')) {
				return;
			}

			var selectedOptions = getSelectedOptions();
			persistAnswers();

			console.log('Selected:', selectedOptions.map(function (opt) { return opt.getAttribute('data-value'); }));

			// default next step
			var next = continueBtn.getAttribute('data-next');

			// if any selected option is conditional, its conditional-next overrides the default
			// (if multiple conditional options are selected at once, the first one found wins)
			var conditionalOption = selectedOptions.find(function (opt) {
				return opt.getAttribute('data-conditional') === 'true' && opt.getAttribute('data-conditional-next');
			});

			if (conditionalOption) {
				next = conditionalOption.getAttribute('data-conditional-next');
			}

			if (next) {
				showQuizStep('tcc-quiz-' + next);
			}
		});
	}

	if (backBtn) {
		backBtn.addEventListener('click', function () {
			var prev = this.getAttribute('data-prev');

			// only reset selections/answers if this step actually has selectable options
			if (options.length > 0) {
				options.forEach(function (opt) {
					opt.classList.remove('tcc-is-selected');
				});
				updateContinueVisibility();
				window.TCCQuiz.saveAnswer(quiz.id, [], []);
			}

			if (prev == '1') {
				document.querySelectorAll('.tcc-quiz').forEach(function (quiz) {
					quiz.style.display = 'none';
				});

				document.querySelector('.quiz-start').style.display = 'grid';
				return;
			} else if (prev) {
				showQuizStep('tcc-quiz-' + prev);
				return;
			}
		});
	}

	if (skipBtn) {
		skipBtn.addEventListener('click', function () {
			var next = this.getAttribute('data-next');
			if (next) {
				showQuizStep('tcc-quiz-' + next);
			}
		});
	}
});

document.querySelector('#tcc-quiz-start').addEventListener('click', function (e) {
	e.preventDefault();
	document.querySelector('.quiz-start').style.display = 'none';
	var next = this.getAttribute('data-next');
	if (next) {
		showQuizStep('tcc-quiz-' + next);
	}
});

var loaderObserver = new MutationObserver(function (mutations) {
	mutations.forEach(function (mutation) {
		if (mutation.type !== 'attributes' || mutation.attributeName !== 'style') {
			return;
		}

		var loader = mutation.target;
		if (loader.classList.contains('tcc-quiz-loader') && window.getComputedStyle(loader).display === 'block') {
			startLoaderTimer(loader);
		}
	});
});

document.querySelectorAll('.tcc-quiz-loader').forEach(function (loader) {
	loaderObserver.observe(loader, {
		attributes: true,
		attributeFilter: ['style']
	});

	if (window.getComputedStyle(loader).display === 'block') {
		startLoaderTimer(loader);
	}
});